var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningUnfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4186_134712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.8499 15.3492L10.1249 2.29922C9.89992 1.84922 9.44992 1.69922 8.99992 1.69922C8.54992 1.69922 8.17492 1.92422 7.87492 2.29922L0.14992 15.3492C-0.37508 16.2492 0.22492 17.2992 1.27492 17.2992H16.7249C17.6999 17.3742 18.2999 16.2492 17.8499 15.3492ZM16.8749 16.1742C16.7999 16.2492 16.7249 16.2492 16.7249 16.2492H1.27492C1.27492 16.2492 1.19992 16.2492 1.12492 16.1742C1.12492 16.0992 1.04992 16.0242 1.12492 15.9492L8.84992 2.82422C8.84992 2.82422 8.92492 2.74922 8.99992 2.74922C9.07492 2.74922 9.14992 2.82422 9.14992 2.82422L16.8749 15.9492C16.8749 16.0242 16.8749 16.0992 16.8749 16.1742Z",
    fill: "#C78300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99971 11.75C9.29971 11.75 9.59971 11.525 9.59971 11.225L9.97471 7.25C10.0497 6.65 9.59971 6.125 8.92471 6.125C8.24971 6.125 7.94971 6.65 7.94971 7.25L8.32471 11.225C8.39971 11.525 8.69971 11.75 8.99971 11.75Z",
    fill: "#C78300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15.125C9.62132 15.125 10.125 14.6213 10.125 14C10.125 13.3787 9.62132 12.875 9 12.875C8.37868 12.875 7.875 13.3787 7.875 14C7.875 14.6213 8.37868 15.125 9 15.125Z",
    fill: "#C78300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4186_134712"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningUnfilled);
export default __webpack_public_path__ + "static/media/warning_unfilled.beb9616a0fb27eb9a5a1197d356d5d51.svg";
export { ForwardRef as ReactComponent };